var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 43.3333C16.6667 43.3333 17.0711 40.5025 28.7868 28.7868C40.5025 17.0711 59.4975 17.0711 71.2132 28.7868C75.3641 32.9377 78.0444 38.0024 79.2539 43.3333M16.6667 43.3333V23.3333M16.6667 43.3333H36.6667M83.3333 56.6667C83.3333 56.6667 82.9289 59.4975 71.2132 71.2132C59.4975 82.9289 40.5025 82.9289 28.7868 71.2132C24.6359 67.0623 21.9557 61.9976 20.7461 56.6667M83.3333 56.6667V76.6667M83.3333 56.6667H63.3333",
    stroke: "#123351",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.8997befdda8b2b55f8dd65c1d4bbd92e.svg";
export { ForwardRef as ReactComponent };